import { AccountJwt, accountJwt } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class KeycloakAccountSignInResponseDTO {
  private static validation = JsonSchemaValidator.compile(
    KeycloakAccountSignInResponseDTO.validationSchema()
  );

  constructor(readonly value: KeycloakAccountSignInResponseDTORaw) {
    JsonSchemaValidator.assert(
      KeycloakAccountSignInResponseDTO.validation,
      value
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["token"],
      properties: {
        token: accountJwt
      },
      additionalProperties: false
    };
  }
}

export interface KeycloakAccountSignInResponseDTORaw {
  token: AccountJwt;
}
